<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link class="navbar-brand" to="/"></b-link>
    <b-navbar-nav class="ml-auto">
      <span class="d-none d-sm-block" style="color: #fff;">{{ username }}</span>
      <HeaderDropdown/>
    </b-navbar-nav>
  </header>
</template>
<script>
import auth from '@/auth'
import HeaderDropdown from './HeaderDropdown.vue'

export default {
  components: { HeaderDropdown },
  data () {
    return {
      username: auth.computed.userData().fullName || auth.computed.userData().username
    }
  },
  name: 'c-header',
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    }
  }
}
</script>
